import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpContextToken } from '@angular/common/http';
import { MsalInterceptor } from '@azure/msal-angular';
import { Observable } from 'rxjs';

export const BYPASS_MSAL = new HttpContextToken<boolean>(() => false);

@Injectable()
export class PostalBridgeMsalInterceptor extends MsalInterceptor implements HttpInterceptor {
  override intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.context.get(BYPASS_MSAL)) {
        return next.handle(req);
      }
      return super.intercept(req, next);
  }
}
